<template>
  <el-dialog
    :model-value="contentVisible"
    :title="`${contentTitle} - ${form.proName}`"
    width="50%"
    @close="handleClose"
    top="5vh" 
  >
    <el-form ref="formRef" :model="form" label-width="100px">
      <QuillEditor
        v-model:content="quillContent"
        :key="quillKey"
        contentType="html"
        toolbar="full"
        theme="snow"
        style="height:500px"
        @ready="handleEditorReady"
      />

    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { defineEmits,ref ,defineProps,watch} from 'vue'
import axios from "@/util/axios";
import { ElMessage } from "element-plus";
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import {getServerUrl} from "@/config/sys";

const formRef=ref(null)
const quillKey = ref(0)

const props=defineProps({
  contentTitle:{
    type:String,
    default:'',
    required:true
  },
  contentValue:{
    type:Object,
    default:()=>{}
  },
  contentVisible: { 
    type: Boolean,
    default: false
  },
})



const form=ref({
  id: -1,
  proName:'',
  proContent: ""
})

const resetFormValue = () => {
  form.value = {
    id: -1,
    proName:'',
    proContent: ""
  };
};
const emits=defineEmits(['update:modelValue','initProductList'])

// 关闭表单
const handleClose = () => {
  formRef.value.resetFields();
  quillKey.value++;  // 强制重新渲染 QuillEditor
  resetFormValue();
  emits('update:modelValue',false)
}

//不直接绑定在fromg上，因为quillConent会改变，所以要单独绑定
const quillContent = ref('');
const handleConfirm = () => {
  // 同步 quillContent到from中
  form.value.proContent = quillContent.value;
  formRef.value.validate(async (valid) => {
    if (valid) {
      console.log("xxx")
       try{
        let result=await axios.post("admin/product/saveContent",form.value);
        let data=result.data;
        if(data.code==0){
          ElMessage.success("执行成功");
          formRef.value.resetFields();
          emits("initProductList")
          handleClose();
        }else{
          ElMessage.error(data.msg);
        }
      }catch(err){
        console.log("error:"+err)
        ElMessage.error('系统运行出错，请联系管理员');
      }
    } else {
      return false
    }
  })
}

const handleEditorReady = (quill) => {
  // 获取图片工具栏按钮
  const toolbar = quill.getModule('toolbar')
  
  // 自定义图片上传处理
  toolbar.addHandler('image', () => {
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')
    input.click()
    
    input.onchange = async () => {
      const file = input.files[0]
      if (file) {
        const formData = new FormData()
        formData.append('file', file)
        
        try {

          // 修改此处：在路径后加上 form.value.id
          let uploadUrl = '/uploadImage/contentImage/'
          if (form.value.id && form.value.id !== -1) {
            uploadUrl += form.value.id
          }

          // 调用后端图片上传接口
          const response = await axios.post(uploadUrl, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          // 假设返回的图片路径在 response.data.url
          const imageUrl = getServerUrl() + response.data.data.src
          
          // 获取当前光标位置
          const range = quill.getSelection()
          if (range) {
            // 插入图片路径而不是base64
            quill.insertEmbed(range.index, 'image', imageUrl)
          }
        } catch (error) {
          ElMessage.error('图片上传失败')
          console.error('Upload error:', error)
        }
      }
    }
  })
}

watch(
  ()=>props.contentValue,
  ()=>{
    // console.log(props.contentValue.id)
    quillKey.value++;
    // console.log(props.contentValue.id);
    form.value=props.contentValue;
    quillContent.value = props.contentValue.proContent || '';
  },
  {deep:true,immediate:true}
)

</script>

<style scoped>

</style>